import { styled } from '@mui/material/styles';
import React, { useContext } from 'react';
import BaseImageSlider from './BaseImageSlider';

const PREFIX = 'ImageSlider';

const classes = {
  imageSlider: `${PREFIX}-imageSlider`,
  container: `${PREFIX}-container`,
};

const Root = styled('div')(({ theme: Theme }) => ({
  [`&.${classes.imageSlider}`]: {
    position: 'relative',
    width: '100%',

    // These might be use case specific and should be extracted in the future
    aspectRatio: '16 / 9',
    flexShrink: 0,
    maxHeight: 'calc(40vh - 64px)', // calculates 40% of the available content size, 64px is the height of app bar
  },

  [`& .${classes.container}`]: {
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
}));

interface IProps {
  children: React.ReactNode;
  overlay?: React.ReactNode;
}

const SliderContext = React.createContext<number>(0);

const ImageSlider = (props: IProps) => {
  const [currentSlide, setCurrentSlide] = React.useState(0);

  if (React.Children.count(props.children) === 0) {
    return null;
  }

  return (
    <SliderContext.Provider value={currentSlide}>
      <Root className={classes.imageSlider}>
        <div className={classes.container}>
          <BaseImageSlider onSlideChanged={setCurrentSlide} currentSlide={currentSlide}>
            {props.children}
          </BaseImageSlider>
        </div>
        {props.overlay}
      </Root>
    </SliderContext.Provider>
  );
};

export const useCurrentSlide = (): number => {
  return useContext(SliderContext);
};

export default ImageSlider;
